import React from 'react';
import { OperatorTypeDetails } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import PropTypes from 'prop-types';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import BooleanChannel from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BooleanChannel/BooleanChannel';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import BaseTemperatureChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BaseTemperatureChannel/BaseTemperatureChannel';
import AnalogComputedChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/AnalogComputedChannel/AnalogComputedChannel';
import RaaExtremeTempFaultChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/RaaExtremeTempFaultChannel';
import AppTypes from '@avtechsoftware/ra-javascript-utilities/src/types/AppTypes';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import { useSelector } from 'react-redux';
import IntegerAsBooleanChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/IntegerAsBooleanChannel/IntegerAsBooleanChannel';
import DigitalParticulateTemperatureFaultChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/DigitalParticulateTemperatureFaultChannel/DigitalParticulateTemperatureFaultChannel';
import Alert from '../../../../classes/Alert';
import ClassUtility from '../../../../utility/ClassUtility';
import { getAnalogComputedUnit } from '../../../../redux/slices/deviceList/deviceListHelperUtils';
import { selectSensorMap } from '../../../../redux/slices/deviceList/deviceListSlice';

function ThresholdSelect(props) {
  const {
    alert,
    setAlert,
    errorList,
  } = props;
  const sensorMap = useSelector(selectSensorMap);
  const channel = ChannelService.getChannelGroupChannelByAppType(
    alert.channelKey.channelGroupType,
    alert.channelKey.channelIndex,
    alert.channelKey.channelType,
    AppTypes.CLOUD,
  );
  const operators = channel.channelType.thresholdOperators;

  const handleDisplayDelta = () => {
    const { channelGroupType, channelIndex } = alert.channelKey;
    if (channelGroupType === 1500 && channelIndex === 1) {
      return '\u0394';
    }
    return '';
  };

  const handleChangeTempScale = (e) => {
    const { value } = e.target;
    const updatedAlert = ClassUtility.cloneObject(alert);
    updatedAlert.temperatureScale = value;
    setAlert(updatedAlert);
  };

  const handleChangeValue = (e) => {
    const { value } = e.target;
    const updatedAlert = ClassUtility.cloneObject(alert);
    updatedAlert.triggerCondition.value = value;
    setAlert(updatedAlert);
  };

  const handleBooleanValueChange = (e) => {
    const { value } = e.target;
    const integerValue = parseInt(value, 10);
    const updatedAlert = ClassUtility.cloneObject(alert);
    // eslint-disable-next-line max-len
    if (channel instanceof RaaExtremeTempFaultChannel || channel instanceof DigitalParticulateTemperatureFaultChannel) {
      updatedAlert.triggerCondition.operator = integerValue === 1 ? '<' : '>';
    } else {
      updatedAlert.triggerCondition.operator = '=';
    }
    updatedAlert.triggerCondition.value = integerValue;
    setAlert(updatedAlert);
  };

  const handleOperatorChange = (e) => {
    const { value } = e.target;
    const updatedAlert = ClassUtility.cloneObject(alert);
    updatedAlert.triggerCondition.operator = value;
    setAlert(updatedAlert);
  };
  return (
    <FormErrorHandler errorList={errorList}>
      <ConditionalRender show={alert.channelKey.channelType !== 0}>
        <div>
          <ConditionalRender show={channel instanceof IntegerAsBooleanChannel
              || channel instanceof RaaExtremeTempFaultChannel}
          >
            <div className="form-group row">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="col-form-label col-md-3 text-md-right">is</label>
              <div className="col-auto">
                <AltErrorWrapper fieldId="startThresholdValue">
                  <select
                    className="form-control"
                    onChange={handleBooleanValueChange}
                    value={alert.triggerCondition.value}
                  >
                    <option
                      value={1}
                    >
                      {channel.falseDisplayValue}
                    </option>
                    <option
                      value={0}
                    >
                      {channel.trueDisplayValue}
                    </option>
                  </select>
                </AltErrorWrapper>
              </div>
            </div>
          </ConditionalRender>
          <ConditionalRender show={(channel instanceof BooleanChannel
              && !(channel instanceof RaaExtremeTempFaultChannel))}
          >
            <div className="form-group row">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="col-form-label col-md-3 text-md-right">is</label>
              <div className="col-auto">
                <AltErrorWrapper fieldId="startThresholdValue">
                  <select
                    className="form-control"
                    onChange={handleBooleanValueChange}
                    value={alert.triggerCondition.value}
                  >
                    <option
                      value={0}
                    >
                      {channel.getDisplayValue(0)}
                    </option>
                    <option
                      value={1}
                    >
                      {channel.getDisplayValue(1)}
                    </option>
                  </select>
                </AltErrorWrapper>
              </div>
            </div>
          </ConditionalRender>
          {/* eslint-disable-next-line max-len */}
          <ConditionalRender show={!(channel instanceof BooleanChannel) && !(channel instanceof IntegerAsBooleanChannel)}>

            <div className="form-group row flex-sm-nowrap">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="col-form-label col-md-3 text-md-right">is</label>
              <div className="col-sm-8" style={{ whiteSpace: 'nowrap' }}>
                <AltErrorWrapper fieldId="startThresholdValue">
                  <div className="form-inline">
                    <select
                      className="form-control w-auto"
                      onChange={handleOperatorChange}
                      value={alert.triggerCondition.operator}
                      style={{ border: '1px solid #ced4da', borderWidth: '0.5px' }}
                    >
                      {operators.map((operatorType, index) => {
                        const operator = OperatorTypeDetails[operatorType];
                        return (
                          <option
                            key={index}
                            value={operator.symbol}
                          >
                            {operator.label.replace('is', '')}
                          </option>
                        );
                      })}
                    </select>
                    <input
                      className="form-control w-25 mx-1"
                      type="text"
                      value={alert.triggerCondition.value}
                      onChange={handleChangeValue}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      style={{ border: '1px solid #ced4da', borderWidth: '0.5px' }}
                    />
                    <ConditionalRender show={channel instanceof BaseTemperatureChannel}>
                      <select
                        className="form-control w-25 border-1"
                        value={alert.temperatureScale}
                        onChange={handleChangeTempScale}
                        style={{ border: '1px solid #ced4da', borderWidth: '0.5px' }}
                      >
                        <option value="C">
                          {handleDisplayDelta()}
                          {'\u00b0C'}
                        </option>
                        <option value="F">
                          {handleDisplayDelta()}
                          {'\u00b0F'}
                        </option>
                      </select>
                    </ConditionalRender>
                    <ConditionalRender show={!(channel instanceof BaseTemperatureChannel)}>
                      <span>
                        {channel instanceof AnalogComputedChannel
                          ? getAnalogComputedUnit(
                            {
                              macAddress: alert.channelKey.macAddress,
                              channelGroupTypeId: alert.channelKey.channelGroupType,
                              channelGroupIndex: alert.channelKey.channelGroupIndex,
                            },
                            sensorMap,
                          )
                          : channel.getUnits()}
                      </span>
                    </ConditionalRender>
                  </div>
                </AltErrorWrapper>
              </div>
            </div>
          </ConditionalRender>
        </div>
      </ConditionalRender>
    </FormErrorHandler>
  );
}

ThresholdSelect.propTypes = {
  alert: PropTypes.instanceOf(Alert).isRequired,
  setAlert: PropTypes.func.isRequired,
  errorList: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
};

export default ThresholdSelect;
